import React from "react";

//Table
import { TableUsers } from "@components/Makansafe/Users";

function UsersMakansafePage(props) {
    return (
        <div className="makansafe-users-page">
            <div className="boxPortlet">
                <TableUsers {...props} />
            </div>
        </div>
    );
}

export default UsersMakansafePage;

